<template>
<div>
    <div class="filter-table mb-3">
        <form @submit.prevent="loadTenants">
            <div class="flex ai-fe jc-sb">
                <div class="flex fs-09 mr-3">
                    <div>
                        <label for="facility-number-filter">Facility Number</label>
                        <input id="facility-number-filter" type="text" v-model="tenant_filter.facility_number" />
                    </div>

                    <div class="ml-3">
                        <label for="unit-filter">Unit</label>
                        <input id="unit-filter" type="text" v-model="tenant_filter.unit" />
                    </div>

                    <div class="ml-3">
                        <label for="name-filter">Tenant Name</label>
                        <input id="name-filter" type="text" v-model="tenant_filter.name" />
                    </div>

                    <div class="ml-3">
                        <label for="policy-number-filter">Policy Number</label>
                        <input id="policy-number-filter" type="text" v-model="tenant_filter.policy_number" />
                    </div>
                </div>

                <div>
                    <button class="mr-2" type="reset" @click="resetFilters">Reset</button>
                    <button type="submit">Search</button>
                </div>
            </div>
        </form>
    </div>

    <div class="flex ai-c jc-sb mb-3">
        <div class="flex-33"></div>

        <div class="ta-c flex-33">
            <vue-table-pagination
                ref="tenants_table_pagination"
                @vuetable-pagination:change-page="onChangePage">
            </vue-table-pagination>
        </div>

        <div class="ta-r flex-33">
            <vue-table-pagination-info ref="tenants_table_info"
                info-template="{total} total tenants"
                no-data-template="" />
        </div>
    </div>

    <div>
        <vue-table ref="tenants_table"
            :class="['table-loads', { loading: is_loading_tenants }]"
            api-url="/api/tenants"
            :load-on-start="false"
            :per-page="100"
            table-height="475px"
            :append-params="api_params"
            data-path="data.data"
            pagination-path="data.pagination"
            :http-options="http_options"
            :fields="columns"
            :data-manager="manageTableFunc"
            no-data-template="<span>No tenants to show.</span>"
            @vuetable:pagination-data="onPaginationData"
            @vuetable:loading="is_loading_tenants = true"
            @vuetable:loaded="is_loading_tenants = false"
            @vuetable:load-error="onTableLoadError">
            <template slot="name" slot-scope="props">
                <div class="flex jc-sb">
                    <span
                        v-if="props.rowData.last_name !== null"
                        class="row-name"
                        :title="`${props.rowData.last_name}, ${props.rowData.first_name}`">
                        {{ props.rowData.last_name }}, {{ props.rowData.first_name }}
                    </span>
                    <span
                        v-else
                        class="row-name"
                        :title="props.rowData.first_name">
                        {{ props.rowData.first_name }}
                    </span>

                    <span
                        v-show="props.rowData.tagged_for_removal"
                        class="as-c"
                        title="Flagged for deletion">
                        <i class="danger-text material-icons">flag</i>
                    </span>
                </div>
            </template>
        </vue-table>
    </div>
</div>
</template>

<script>
import store from "@/store"
import Vue from "vue"

export default {
    data () {
        return {
            checked: [],
            columns: [
                {
                    name: "facility_number",
                    sortField: "facility_number",
                    title: "Facility Number",
                    width: "175px"
                },
                {
                    name: "unit",
                    sortField: "unit",
                    title: "Unit",
                    dataClass: "center aligned",
                    titleClass: "center aligned",
                    width: "125px"
                },
                {
                    name: "__slot:name",
                    sortField: "last_name",
                    title: "Name"
                },
                {
                    name: "policy_number",
                    sortField: "policy_number",
                    title: "Policy Number",
                    width: "250px"
                }
            ],
            http_options: {
                baseURL: this.$http.defaults.baseURL,
                headers: {
                    "X-Authorization": store.state.token.token
                },
                transformResponse: [(raw) => {
                    try {
                        return JSON.parse(raw)
                    } catch (error) {
                        this.load_tenants_error = "Unknown error loading tenants."

                        return raw
                    }
                }]
            },
            is_loading_tenants: false,
            manageTableFunc: this.manageTable.bind(this),
            tenant_filter: {
                facility_number: null,
                name: null,
                policy_number: null,
                unit: null
            }
        }
    },

    computed: {
        api_params () {
            const params = {
                filter: "setup_insurance"
            }

            for (const key in this.tenant_filter) {
                const value = this.tenant_filter[key]

                if (value && value.length > 0) {
                    params[key] = value
                }
            }

            return params
        }
    },

    mounted () {
        this.loadTenants()
    },

    methods: {
        /**
         * Change the pagination page when requested.
         *
         * @param object page Page
         *
         * @return null
         */
        onChangePage (page) {
            this.$refs.tenants_table.changePage(page)
        },

        /**
         * Update the pagination component when data is received.
         *
         * @param object paginationData Pagination data
         *
         * @return null
         */
        onPaginationData (paginationData) {
            this.$refs.tenants_table_pagination.setPaginationData(paginationData)
            this.$refs.tenants_table_info.setPaginationData(paginationData)
        },

        onTableLoadError ({ response: { data } }) {
            console.warn(data)

            this.$eventManager.emit("add-toast", { message: "Error loading tenants", type: "error" })
        },

        async loadTenants () {
            Vue.nextTick(() => {
                this.$refs.tenants_table.reload()
            })
        },

        /**
         * Set the sort field when the user requests sorting.
         *
         * @param object data Row data
         *
         * @return null
         */
        manageTable (data) {
            if (data.length) {
                this.sort_field = {
                    field: data[0].sortField,
                    direction: data[0].direction
                }
            } else {
                this.sort_field = {}
            }
        },

        resetFilters () {
            for (const key in this.tenant_filter) {
                this.tenant_filter[key] = ""
            }

            this.loadTenants()
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/insurance-policy-management-page/ListTenantsTab.vue